import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import Slider from 'react-slick';
import { WelcomeVideo } from '../../../../interfaces/interfaces';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../services/helper';
import VideoElement from '../VystemLight/oneonone/VideoElement';

const Viewer = dynamic(() => import('react-viewer'), { ssr: false });

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: <FontAwesomeIcon style={{ fill: 'white' }} icon={faChevronLeft} />,
  nextArrow: <FontAwesomeIcon style={{ fill: 'white' }} icon={faChevronRight} />,
};

interface ZukunSliderProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  slides: string[];
  welcomeVideo?: WelcomeVideo;
  withViewer?: boolean;
  viewerOpen: (open: boolean) => void;
}

const ZukunSlider = ({ slides, className, welcomeVideo, withViewer, viewerOpen, ...props }: ZukunSliderProps) => {
  const [viewerVisible, setViewerVisible] = useState<boolean>(false);
  const [viwerIndex, setViewerIndex] = useState<number>(0);

  const event = useSelector((state) => state.common.event);

  function openViewer(idx: number) {
    setViewerIndex(idx);
    setViewerVisible(true);
    viewerOpen(true);
    try {
      axios.post('/tracking/track', { event: 'IMAGE_VIEW', eventid: event?._id, args: { fileId: slides[idx] } });
    } catch (err) {
      console.error(err);
    }
  }

  function closeViewer() {
    console.log('Closing viewer');
    setViewerVisible(false);
    viewerOpen(false);
  }

  return (
    <div className={`zukun-slider relative ${className}`} {...props}>
      <Viewer
        visible={viewerVisible}
        onClose={closeViewer}
        images={slides.map((slide) => ({ src: createDisplayLink(slide), alt: 'image' }))}
        zoomable={false}
        rotatable={false}
        scalable={false}
        noImgDetails
        defaultScale={1.5}
        noToolbar
        drag={false}
        noFooter
        activeIndex={viwerIndex}
      />

      <Slider {...settings} infinite={false}>
        {welcomeVideo && <VideoElement currentIndex={0} visible={true} key={welcomeVideo.video} welcomeVideo={welcomeVideo} />}
        {slides.map((slide, idx) => (
          <div key={slide} className="image-outer">
            <div
              className="w-full bg-cover bg-center h-full image-inner"
              style={{ backgroundImage: `url(${createDisplayLink(slide)})`, ...(withViewer ? { cursor: 'pointer' } : {}) }}
              onClick={() => withViewer && openViewer(idx)}
            />
          </div>
        ))}
      </Slider>
      <style global jsx>{`
        .react-viewer-canvas {
          background: black;
        }
        .react-viewer-close {
          top: 60px !important;
          right: 15px !important;
        }
        .image-outer {
          height: 0;
          padding-top: 56.25%;
          position: relative;
        }
        .image-inner {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .zukun-slider {
          svg {
            width: 16px !important;
            path {
              fill: white;
            }
          }
          .slick-slide {
            padding: 0 8px;
            box-sizing: border-box;
          }
        }
      `}</style>
    </div>
  );
};

export default ZukunSlider;
